module.exports = "/static/assets/d04305129eadebdbd60bbbcefd876177.png";